// The one list of app pages.
//
// To bring a hidden page back, set `visible: true`. Its code and data are never
// removed. Running locally (`npm start`), hidden pages still open from the
// "Ascunse" group in the menu, so they can be checked before being turned on.
//
// `primary` pages get a slot in the phone's bottom bar. Keep at most 5; the rest
// go under "Mai mult".
export const PAGES = [
  { id: 'fields',          visible: true,  primary: true,  short: { ro: 'Câmpuri',   en: 'Fields' } },
  { id: 'parcels',         visible: true,  primary: true,  short: { ro: 'Parcele',   en: 'Parcels' } },
  { id: 'arendamanager',   visible: true,  primary: true,  short: { ro: 'Arendă',    en: 'Rent' } },
  { id: 'stockadjustment', visible: true,  primary: true,  short: { ro: 'Stoc',      en: 'Stock' } },
  { id: 'motorina',        visible: true,  primary: true,  short: { ro: 'Motorină',  en: 'Diesel' } },
  { id: 'equipment',       visible: true,  primary: false, short: { ro: 'Utilaje',   en: 'Machinery' } },
  { id: 'settings',        visible: true,  primary: false, short: { ro: 'Setări',    en: 'Settings' } },

  { id: 'dashboard',       visible: false, primary: false, short: { ro: 'Panou',     en: 'Dashboard' } },
  { id: 'weather',         visible: false, primary: false, short: { ro: 'Vreme',     en: 'Weather' } },
  { id: 'tasks',           visible: false, primary: false, short: { ro: 'Sarcini',   en: 'Tasks' } },
  { id: 'inventory',       visible: false, primary: false, short: { ro: 'Inventar',  en: 'Inventory' } },
  { id: 'lucrari',         visible: false, primary: false, short: { ro: 'Lucrări',   en: 'Field work' } },
  { id: 'costuri',         visible: false, primary: false, short: { ro: 'Costuri',   en: 'Costs' } },
  { id: 'seasons',         visible: false, primary: false, short: { ro: 'Sezoane',   en: 'Seasons' } },
  { id: 'workplanning',    visible: false, primary: false, short: { ro: 'Planificare', en: 'Planning' } },
  { id: 'worker',          visible: false, primary: false, short: { ro: 'Sesiune',   en: 'Work session' } },
];

const isDevelopment = process.env.NODE_ENV === 'development';

export const getPage = (id) => PAGES.find((page) => page.id === id);

// Can this page be opened right now?
export const isPageAvailable = (id) => {
  const page = getPage(id);
  return Boolean(page?.visible) || isDevelopment;
};

// Puts menu items in the order of the list above and drops unavailable pages.
export const arrangeNavItems = (items) =>
  items
    .filter((item) => isPageAvailable(item.id))
    .sort((a, b) => PAGES.findIndex((p) => p.id === a.id) - PAGES.findIndex((p) => p.id === b.id));
